import {useState, useEffect} from 'react'
import {t} from 'i18next'
import { FormGroup, Label, Button } from 'reactstrap'

import { isNull } from '../../izUtils'
import Maps from './custom/Maps'
import DisplayHistory from '../../helpers/DisplayHistory'
import DictionaryInfoButton from '../dictionary/DictionaryInfoButton'

const TextInput = ({data, onChange, onBlur, showErrors, lsFilterName, history, component, showDictionary}) => {
    const { type, name, display, errors, title, disabled, mandatory} = data
    const isFilter = !isNull(lsFilterName)

    const [value, setvalue] = useState("")

    useEffect(() => {
        setvalue(data.value === null ? '' : data.value)
    }, [data.value])

    const handleChange = (e) => {
        setvalue(e.target.value)

        // Save filter data to LS, so it can be used if user clicks "Confirm" button
        if (isFilter) {
            let lsFilter = JSON.parse(localStorage.getItem(lsFilterName))
            if (!isNull(lsFilter)) {
                for (const filterName in lsFilter) {
                    if (filterName === name) {
                        lsFilter[filterName].value = e.target.value;
                        localStorage.setItem(lsFilterName, JSON.stringify(lsFilter))
                    }
                }
            }
        }
    };

    // Regular fields call BE on blur
    const handleBlur = () => {
        if (!isFilter && !isNull(onBlur)) onBlur(value, name)
    }

    // Filter fields call BE when enter is pressed
    const handleKeyDown = (e) => {
        if (isFilter && e.keyCode === 13) onChange(value, name)
    }

    let gmapsLocation = null;
    if (!isFilter && (name === 'location' || name === 'google_location')) {
        gmapsLocation = value;
    }

    const checkLocation = () => {
        onBlur(value, name, true, false)
    }

    const checkDistance = () => {
        onBlur(value, name, false, true)
    }

    const changeLocation = (address) => {
        onBlur(address, name)
    }

    if (display) {
        return (
            <FormGroup style={{ position: 'relative' }}>
                <div className="d-flex align-items-center">
                    <Label>{title + (mandatory ? " *" : "")}</Label>
                    {(showDictionary && showDictionary.fields?.includes(name)) &&
                        <DictionaryInfoButton code={`${showDictionary.form}.${isFilter ? 'filter' : 'form'}.${name}`} id={`${showDictionary.form}.${isFilter ? 'filter' : 'form'}.${name}`} marginBottom="0.2rem" />
                    }
                </div>
                <input
                    className={"form-control"}
                    disabled={disabled}
                    type={type}
                    name={name}
                    placeholder={t(`form.placeholder.${name}`)}
                    onChange={handleChange}
                    value={value}
                    onBlur={handleBlur}
                    onKeyDown={handleKeyDown}
                />
                {!isNull(gmapsLocation) && <a href={'https://www.google.com/maps/place/' + gmapsLocation} target="_blank" rel="noreferrer" className='gmaps-location-marker'><i className="fa fa-map-marker"></i></a>}
                {name === 'work_estimate' && <div className='input-note'>{t(`form.note.${name}`)}</div>}
                {!isNull(showErrors) && showErrors && !isNull(errors) && errors.length !== 0 && <div style={{ color: "red", marginBottom: "10px" }}>{errors.map((error, index) => <div key={"error-"+index}>{error}</div>)}</div>}
                {(!isNull(history) && history.length > 0) && <DisplayHistory history={history} data={data} />}
                {name === 'google_location' && <Maps coords={data.value} changeLocation={changeLocation} showDictionary={showDictionary} />}
                {(!isFilter && component?.id === 'createFacility' && name === 'location') &&
                    <div className="d-flex flex-wrap">
                        <div className="d-flex align-items-center mt-2 me-4">
                            <Button color="primary" className="btn-sm" onClick={checkLocation}>{t('form.checkLocation')}</Button>
                            {showDictionary && <DictionaryInfoButton code="client_facilities.form.location_check" id="client_facilities.form.location_check" /> }
                        </div>
                        <div className="d-flex align-items-center mt-2">
                            <Button color="primary" className="btn-sm" onClick={checkDistance}>{t('form.checkDistance')}</Button>
                            {showDictionary && <DictionaryInfoButton code="client_facilities.form.location_distance" id="client_facilities.form.location_distance" /> }
                        </div>
                    </div>
                }
            </FormGroup>
        );
    } else {
        return null;
    }
}

export default TextInput